export function getStoredAccessToken(): string | null {
	return localStorage.getItem(import.meta.env.VITE_AUTH_TOKEN_STORAGE_KEY)
}

export function setStoredAccessToken(token: string): void {
	localStorage.setItem(import.meta.env.VITE_AUTH_TOKEN_STORAGE_KEY, token)
}

export function clearStoredAccessToken(): void {
	localStorage.removeItem(import.meta.env.VITE_AUTH_TOKEN_STORAGE_KEY)
}
